const PROFILE_LOGS_KEY = {
  ALL: 'all',
  CURRENT: 'current',
  DATA: 'data'
}

export { PROFILE_LOGS_KEY }
